import * as React from 'react';

export const AverageTurnout = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="users-group">
      <path
        id="Vector"
        opacity="0.4"
        d="M13.785 13.3916H10.2159C6.55094 13.3916 5.25098 16.0636 5.25098 18.3516C5.25098 20.3836 6.38196 21.5016 8.43396 21.5016H15.568C17.62 21.5016 18.751 20.3826 18.751 18.3516C18.75 16.0646 17.45 13.3916 13.785 13.3916Z"
        fill="black"
      />
      <path
        id="Vector_2"
        d="M12.0081 11.5149C13.9501 11.5149 15.5291 9.94191 15.5291 8.00891C15.5291 6.07491 13.9491 4.50293 12.0081 4.50293C10.0671 4.50293 8.48804 6.07591 8.48804 8.00891C8.48804 9.94191 10.0661 11.5149 12.0081 11.5149Z"
        fill="black"
      />
      <path
        id="Vector_3"
        opacity="0.4"
        d="M22.5 12.6526C22.5 14.2126 21.6399 15.0725 20.0699 15.0725H19.65C19.52 15.0725 19.4199 15.0026 19.3699 14.8926C18.6399 13.5726 17.41 12.5325 15.64 12.1125C15.41 12.0525 15.3099 11.7725 15.4799 11.6125C16.1699 10.9625 16.67 10.1126 16.89 9.1626C16.92 9.0326 17.04 8.93262 17.18 8.93262H18.79C21.53 8.93262 22.5 10.9426 22.5 12.6526Z"
        fill="black"
      />
      <path
        id="Vector_4"
        d="M20.1801 5.17297C20.1801 6.65297 18.98 7.85291 17.51 7.85291C17.436 7.85291 17.363 7.8489 17.292 7.8429C17.2 7.8349 17.1321 7.80498 17.0861 7.75598C17.0401 7.70698 17.0141 7.65998 17.0081 7.58398C16.9011 6.23298 16.2481 5.03789 15.2691 4.21289C15.2081 4.16089 15.178 4.12594 15.163 4.05994C15.149 3.99694 15.147 3.92491 15.184 3.85791C15.642 3.04891 16.512 2.50195 17.51 2.50195C18.98 2.50295 20.1801 3.70297 20.1801 5.17297Z"
        fill="black"
      />
      <path
        id="Vector_5"
        opacity="0.4"
        d="M1.5 12.6526C1.5 14.2126 2.36005 15.0725 3.93005 15.0725H4.34998C4.47998 15.0725 4.58 15.0026 4.63 14.8926C5.36 13.5726 6.58999 12.5325 8.35999 12.1125C8.58999 12.0525 8.69002 11.7725 8.52002 11.6125C7.83002 10.9625 7.32999 10.1126 7.10999 9.1626C7.07999 9.0326 6.95995 8.93262 6.81995 8.93262H5.20996C2.46996 8.93262 1.5 10.9426 1.5 12.6526Z"
        fill="black"
      />
      <path
        id="Vector_6"
        d="M3.81995 5.17297C3.81995 6.65297 5.01999 7.85291 6.48999 7.85291C6.56399 7.85291 6.63701 7.8489 6.70801 7.8429C6.80001 7.8349 6.86794 7.80498 6.91394 7.75598C6.95994 7.70698 6.98594 7.65998 6.99194 7.58398C7.09894 6.23298 7.75196 5.03789 8.73096 4.21289C8.79196 4.16089 8.82204 4.12594 8.83704 4.05994C8.85104 3.99694 8.85304 3.92491 8.81604 3.85791C8.35804 3.04891 7.48799 2.50195 6.48999 2.50195C5.01999 2.50295 3.81995 3.70297 3.81995 5.17297Z"
        fill="black"
      />
    </g>
  </svg>
);
